import React from 'react';
import { arrayOf, bool, func, node, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { LinkedLogo, NamedLink } from '../../../../components';

import Field from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionFooter.module.css';

import footerLogo from './../../../../assets/footer-logo.png';

// The number of columns (numberOfColumns) affects styling

const GRID_CONFIG = [
  { contentCss: css.contentCol1, gridCss: css.gridCol1 },
  { contentCss: css.contentCol2, gridCss: css.gridCol2 },
  { contentCss: css.contentCol3, gridCss: css.gridCol3 },
  { contentCss: css.contentCol4, gridCss: css.gridCol4 },
];

const getIndex = numberOfColumns => numberOfColumns - 1;

const getContentCss = numberOfColumns => {
  const contentConfig = GRID_CONFIG[getIndex(numberOfColumns)];
  return contentConfig ? contentConfig.contentCss : GRID_CONFIG[0].contentCss;
};

const getGridCss = numberOfColumns => {
  const contentConfig = GRID_CONFIG[getIndex(numberOfColumns)];
  return contentConfig ? contentConfig.gridCss : GRID_CONFIG[0].gridCss;
};

// Section component that's able to show blocks in multiple different columns (defined by "numberOfColumns" prop)
const SectionFooter = props => {
  const {
    sectionId,
    className,
    rootClassName,
    numberOfColumns,
    socialMediaLinks,
    slogan,
    appearance,
    copyright,
    blocks,
    options,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const linksWithBlockId = socialMediaLinks?.map(sml => {
    return {
      ...sml,
      blockId: sml.link.platform,
    };
  });

  const showSocialMediaLinks = socialMediaLinks?.length > 0;

  const date = new Date();
  const year = date.getFullYear();

  const site =
    process.env.REACT_APP_MARKETPLACE_NAME ||
    process.env.REACT_APP_MARKETPLACE_ROOT_URL ||
    'Bowtackle';

  // use block builder instead of mapping blocks manually

  return (
    <>
      <SectionContainer
        as="footer"
        id={sectionId}
        className={className || css.root}
        rootClassName={rootClassName}
        appearance={appearance}
        options={fieldOptions}
      >
        <div className={css.footer}>
          <div className={classNames(css.content, getContentCss(numberOfColumns))}>
            <div>
              {/* <LinkedLogo
              rootClassName={css.logoLink}
              logoClassName={css.logoWrapper}
              logoImageClassName={css.logoImage}
            /> */}
              <NamedLink name="LandingPage" className={css.logoWrapper}>
                <img src={footerLogo} className={css.logoImage} />
              </NamedLink>
            </div>
            {/* <div className={css.sloganMobile}>
            <Field data={slogan} className={css.slogan} />
          </div> */}
            {/* <div className={css.detailsInfo}>
            {<div className={css.sloganDesktop}>
              <Field data={slogan} className={css.slogan} />
            </div>}
            {showSocialMediaLinks ? (
              <div className={css.icons}>
                <BlockBuilder blocks={linksWithBlockId} sectionId={sectionId} options={options} />
              </div>
            ) : null}
            <Field data={copyright} className={css.copyright} />
          </div> */}
            <div className={classNames(css.grid, getGridCss(numberOfColumns))}>
              <BlockBuilder blocks={blocks} sectionId={sectionId} options={options} />
            </div>
          </div>
        </div>
      </SectionContainer>
      <div className={css.additionalFooter}>
        {/* <div>&nbsp;</div> */}
        <div className={css.socialMediaContainer}>
          {showSocialMediaLinks ? (
            <>
              <div className={css.icons}>
                <BlockBuilder blocks={linksWithBlockId} sectionId={sectionId} options={options} />
              </div>
              <div>Follow us on Social media</div>
            </>
          ) : null}
        </div>
        <div>
          &copy; {year} {site}
        </div>
      </div>
    </>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionFooter.defaultProps = {
  className: null,
  rootClassName: null,
  textClassName: null,
  numberOfColumns: 1,
  socialMediaLinks: [],
  slogan: null,
  copyright: null,
  appearance: null,
  blocks: [],
  options: null,
};

SectionFooter.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  numberOfColumns: number,
  socialMediaLinks: arrayOf(object),
  slogan: object,
  copyright: object,
  appearance: object,
  blocks: arrayOf(object),
  options: propTypeOption,
};

export default SectionFooter;
